import React, { PropTypes } from 'react';
import cx from 'classnames';
import { Table } from 'semantic-ui-react';

const onDeleteClick = onDelete => evt => {
  onDelete();
  evt.stopPropagation();
};

const deleteButtonClass = readOnly => {
  return cx('ui basic icon red button delete', {
    disabled: readOnly,
  });
};

const AccountingCodeLine = ({ index, data, onDelete }) => {
  const fieldName = `accountingCodes[${index}]`;
  const idName = `${fieldName}.id`;
  const codeName = `${fieldName}.code`;

  return (
    <Table.Row data-code={data.accounting_code}>
      <Table.Cell width={2}>
        <a
          href="#"
          className={deleteButtonClass(false)}
          onClick={onDeleteClick(onDelete)}
        >
          <i className="remove icon" />
        </a>
      </Table.Cell>
      <Table.Cell width={14} textAlign="left">
        {data.accounting_code}
        <input type="hidden" id={idName} name={idName} value={data.id} />
        <input
          type="hidden"
          id={codeName}
          name={codeName}
          value={data.accounting_code}
        />
      </Table.Cell>
      <Table.Cell width={2} />
    </Table.Row>
  );
};

AccountingCodeLine.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AccountingCodeLine;



// WEBPACK FOOTER //
// ./src/modules/saas/customers/components/AccountingCodeLine.js